import { FetchAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../BaseController';
import { Inject } from '@odinjs/odin';
import { MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { FragmentNames } from '../../codegen';
import { PaymentSummaryAliases } from '../../codegen';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import { resolvePath } from '@philips-internal/oswald-ui-utils';
import UserContext from '../../utils/user-context';
import { AppRoutes } from '../../codegen';
import { Value } from '@philips-internal/oswald-ui-core';
import { CardPaymentSummaryContentApi } from '@philips-emr/patient-components/src';

interface ReportGenerateResponse {
  uri: string;
}

@Controller({ fragment: FragmentNames.PAYMENT_SUMMARY })
class PaymentSummary extends BaseController {

  @Inject(PaymentSummaryAliases.FETCH_PAYMENT_SUMMARY)
    fetchPaymentSummaryApi!: FetchAPI;

  @OnMount({ target: PaymentSummaryAliases.FETCH_PAYMENT_SUMMARY})
  handleMount(event: MountEvent): void {
    const fetchApi = event.target as FetchAPI;

    const accountNumber = this.getHistoryRouteParam<Value>('accountNumber');

    this.context.set({accountNumber: accountNumber, openLocation: true});
    const params = {accountNumber: accountNumber} as Record<string, Value>;
    fetchApi.setParameters(params);
    fetchApi.forceFetch();
  }

  handlerPaymentDataReportLoading(event: MountEvent): void{
    const cardPaymentSummaryApi = event.target as CardPaymentSummaryContentApi;

    cardPaymentSummaryApi.setOnClickReportButton(this.openReportPaymentSummary);
  }

  openReportPaymentSummary = (): void => {
    const accountNumber = this.getHistoryRouteParam<string>('accountNumber');
    this.context.set({ accountNumber });
    const params = {
      accountNumber: accountNumber,
      groupCode: 31
    }

    this.context.set({ reportParams: params });
    const body = { parameters: params};

    HttpService.post<ReportGenerateResponse>(APPLICATION_ENDPOINTS.GET_PAYMENT_DATA_REPORT,  { patientId: UserContext.patientId },{ body }).then<string>(response => {
      return resolvePath(`${APPLICATION_ENDPOINTS.GET_PREVIEW_DOCUMENT}?uri=:uri`, { uri: response.body?.uri });
    }).then(file => {
      const url = file.replace(APPLICATION_ENDPOINTS.GET_PREVIEW_DOCUMENT,'');
      window.open(`${AppRoutes.PREVIEW_ATTACHED_FILE_ROUTE}${url}`,'_blank');

    });
  }
}

export default PaymentSummary;